// extracted by mini-css-extract-plugin
export var centerText = "_4h-8";
export var container = "_4h-0";
export var doughnutContainer = "_4h-7";
export var legend = "_4h-a";
export var legendItemColorDisplay = "_4h-b";
export var legendItemLabel = "_4h-d";
export var legendItemValue = "_4h-c";
export var lg = "_4h-5";
export var maxWidth = "_4h-9";
export var md = "_4h-4";
export var responsive = "_4h-6";
export var sm = "_4h-3";
export var xs = "_4h-2";
export var xxs = "_4h-1";